export interface IPhoneSearchCriteria {
    userIds:Array<string>
}


export class PhoneSearchCriteriaModel implements IPhoneSearchCriteria{
    userIds:Array<string>
}